<template>
  <ul class="list-inline">
    <blog-card v-for="blog in blogs" :key="blog.id" :blog="blog" class="my-3" />
  </ul>
</template>

<script>
import BlogCard from './BlogCard'

export default {
  name: 'BlogsList',
  props: {
    blogs: { type: Array, required: true }
  },
  components: { BlogCard }
}
</script>
